import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import Productreports from "./Productreports";
import Articlereports from "./articlereports";
import Personalreports from "./personalreports";
import classnames from "classnames";
import Config from "../../Config.js";

const Reports = (props) => {
  // useEffect(() => {
  // 	let checkLogin = localStorage.getItem("loginUserID");
  // 	if (checkLogin == "" || checkLogin == "" || checkLogin == undefined) {
  // 		this.props.history.push('Login1');
  // 	}
  // }, []);
  let history = useHistory();
  const location = useLocation();
  const [activePill, setactivePill] = useState(
    location?.state?.ActivePill ? location?.state?.ActivePill : "1"
  );
  const [ProductID, setProductID] = useState(
    location?.state?.ProductID ? location?.state?.ProductID : ""
  );
  const [ArticleID, setArticleID] = useState(
    location?.state?.ArticleID ? location?.state?.ArticleID : ""
  );
  const [PersonalID, setPersonalID] = useState(
    location?.state?.PersonalID ? location?.state?.PersonalID : ""
  );
  console.log("ProductID===|>", ProductID);
  const togglePill = (pill) => {
    if (activePill !== pill) {
      setactivePill(pill);
    }
  };
  const [Articlelist, setArticlelist] = useState([]);
  const [Productlist, setProductlist] = useState([]);
  const [personallist, setpersonallist] = useState([]);

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      GetAllArticle();
      GetAllArticleProduct();
      GetAllpersonalqrcode();
    }
  }, []);
  const GetAllArticle = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let subUserIDList = localStorage.getItem("subUserIDList");
    let EmaptyArrry = [];
    await fetch(Config.apiUrl + "ArticleProduct", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        subUserCompanyID: subUserIDList,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        setArticlelist(result);
      });
    });
  };
  const GetAllArticleProduct = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let subUserIDList = localStorage.getItem("subUserIDList");
    let EmaptyArrry = [];
    await fetch(Config.apiUrl + "ArticleProduct/Products", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        subUserCompanyID: subUserIDList,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        setProductlist(result);
      });
    });
  };
  const GetAllpersonalqrcode = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let subUserIDList = localStorage.getItem("subUserIDList");
    let EmaptyArrry = [];
    await fetch(Config.apiUrl + "QrCodeResourceController", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        subUserCompanyID: subUserIDList,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        setpersonallist(result);
      });
    });
  };

  return (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          {/* <Link to="/dashboard/home">Home</Link> */}
          <Link to="/home">Home</Link>
        </li>
        <li className="breadcrumb-item active">Reports</li>
      </ol>
      <h1 className="page-header">Reports</h1>
      <Nav className="report-header-tab mt-3 report-navpill" pills>
        <NavItem>
          <NavLink
            className={classnames({ active: activePill === "1" })}
            onClick={() => {
              togglePill("1");
            }}
          >
            <span className="d-sm-none">Article</span>
            <span className="d-sm-block d-none">Article</span>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activePill === "2" })}
            onClick={() => {
              togglePill("2");
            }}
          >
            <span className="d-sm-none">Production</span>
            <span className="d-sm-block d-none">Production</span>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activePill === "3" })}
            onClick={() => {
              togglePill("3");
            }}
          >
            <span className="d-sm-none">Personal</span>
            <span className="d-sm-block d-none">Personal</span>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent className="p-15 rounded  mb-4 " activeTab={activePill}>
        <TabPane tabId="1">
          <Articlereports Articlelist={Articlelist} ArticleID={ArticleID} />
        </TabPane>
        <TabPane tabId="2">
          <Productreports Productlist={Productlist} ProductID={ProductID} />
        </TabPane>
        <TabPane tabId="3">
          <Personalreports
            personallist={personallist}
            PersonalID={PersonalID}
          />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default Reports;
